import { ProductContextBase } from '../../baseBtl/context/child/product-context.service';

export class ProductContext extends ProductContextBase {}
